module.exports = __webpack_public_path__ + "static/media/busyplace.bd73f276.jpg";